/* KRYSTO · Panier qui glisse : ajout sans changer de page, quantités, passage au Club */
(function () {
  if (window.kxCart) return;

  var drawer = document.getElementById('kx-cart');
  var overlay = document.getElementById('kx-cart-overlay');
  var body = document.getElementById('kx-cart-body');
  if (!drawer || !body) return;

  // Sur la page panier, on garde le fonctionnement classique
  var onCartPage = /^\/cart\/?$/.test(location.pathname);

  // En aperçu de thème, on garde le bon thème pour recharger le contenu
  var previewParam = '';
  if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') previewParam = '&preview_theme_id=' + Shopify.theme.id;

  function open() {
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); });
    document.documentElement.classList.add('kx-lock');
    var x = drawer.querySelector('[data-kx-cart-close]');
    if (x) x.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('kx-lock');
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 280);
  }

  // Met à jour la pastille du panier dans le header
  function setCount(n) {
    document.querySelectorAll('.kx-header__count').forEach(function (el) {
      if (String(n) !== el.textContent) {
        el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
      }
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    var link = document.getElementById('cart-icon-bubble');
    if (link) link.setAttribute('aria-label', 'Panier, ' + n + ' article(s)');
  }

  // Recharge le contenu du panier depuis Shopify
  function render(message) {
    return fetch('/?section_id=kx-cart-drawer' + previewParam, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.kx-cart__inner');
        if (inner) {
          body.innerHTML = inner.outerHTML;
          setCount(parseInt(inner.getAttribute('data-count'), 10) || 0);
        }
        if (message) {
          var top = body.querySelector('.kx-cart__top');
          var p = document.createElement('p');
          p.className = 'kx-cart__msg';
          p.textContent = message;
          if (top) top.insertAdjacentElement('afterend', p);
        }
      });
  }

  function busy(on) { drawer.classList.toggle('is-busy', on); }

  // Change la quantité d'une ligne (et éventuellement son abonnement)
  function change(line, qty, plan) {
    busy(true);
    var data = { line: line, quantity: qty };
    if (plan) data.selling_plan = plan;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { return render(res.ok ? null : (res.j.description || res.j.message)); })
      .finally(function () { busy(false); });
  }

  // Ajout au panier depuis n'importe quel formulaire produit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (onCartPage || action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return render(res.ok ? null : (res.j.description || res.j.message || 'Impossible d’ajouter ce produit.'));
      })
      .then(open)
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  // Clics dans le panier et sur l'icône du header
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kx-cart-open], [data-kx-cart-close], [data-kx-line]');
    if (!t) return;
    if (t.hasAttribute('data-kx-cart-open')) {
      if (onCartPage) return;
      e.preventDefault();
      open();
    } else if (t.hasAttribute('data-kx-cart-close')) {
      close();
    } else {
      change(parseInt(t.getAttribute('data-kx-line'), 10), parseInt(t.getAttribute('data-kx-qty'), 10), t.getAttribute('data-kx-plan'));
    }
  });
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

  window.kxCart = { open: open, close: close, render: render };
})();
